import React from 'react';

import Header from '../../components/Header';
/**
 * Not found component
 */
const NotFound = () => {
    const navigateToInfince = () => {
        window.location.href = 'https://www.infince.com/';
    };
    return (
        <div className="container">
            <Header />
            <div class="type1-container error-container">
                <h1>Oops! Page not found</h1>
                <p>Sorry, but the page you are looking for doesn't exist.</p>
                <div className="centerd-btn-block">
                    <button className="btn-primary" onClick={navigateToInfince}>
                        Go to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
